import React, { ReactElement } from 'react';
import classNames from 'classnames';
import I18n from 'i18n-js';

import { ReactComponent as AlertCircle } from '~/assets/images/iconsLibrary/alert-circle.svg';

import styles from './InputWrapper.module.scss';

export interface IInputWrapperProps {
  label: string;
  id?: string; // todo: check if it's possible to type it when id is injected by parent
  error?: string;
  errorAction?: {
    error: string;
    component: ReactElement;
  };
  onClickWrapper?: (event: React.MouseEvent<HTMLDivElement>) => void;
}

const InputWrapper: React.FC<IInputWrapperProps & { className?: string }> = ({
  children,
  id,
  label,
  error,
  errorAction,
  className,
  onClickWrapper,
}) => {
  return (
    <div
      className={styles.wrapper}
      onClick={onClickWrapper}
    >
      <label
        className={styles.label}
        htmlFor={id}
      >
        {label}
      </label>
      <div className={classNames(styles.inputWrapper, className)}>
        {children}
      </div>
      {Boolean(error) && (
        <p className={styles.error}>
          <AlertCircle className={styles.errorIcon} />
          {errorAction && errorAction.error === error
            ? errorAction.component
            : I18n.t(error ?? '')}
        </p>
      )}
    </div>
  );
};

export default InputWrapper;
